'use client';
import { lazy, type ComponentProps } from 'react';
export type * from "/tmp/build-511/overrides/components/categories/category-filter-top.tsx";
const Deferred0 = lazy(() => import("@eliadmin/page-island-original/249f7c36a6d1").then(m => ({ default: m.default })));
const Island0 = ((props: NonNullable<ComponentProps<typeof import("/tmp/build-511/overrides/components/categories/category-filter-top.tsx").default>>) => <Deferred0 {...props} />) as typeof import("/tmp/build-511/overrides/components/categories/category-filter-top.tsx").default;
export default Island0;
